import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";
import accessibilityUtil from 'HSNDIR/AccessibilityUtility.js';

/**
    * class HSN.Widget.FancyInput
    *
    * Encapsulates the common functionality of the AddToBag Widget.
    **/
HSN.Widget.FancyInput = function () {
    var application;
    var deviceInformation;
    var fancyInputContainer;
    var inputSelector = '.float-label-input input, .float-label-input textarea';
    var showHideSelector = '.float-label-input .show-hide';
    /**
        * new HSN.Widget.FancyInput.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FancyInput]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        **/
    function init(config) {
        application = config.application;
        deviceInformation = application.DeviceInformation;
        fancyInputContainer = typeof(config.containerName) !== 'undefined' ? $(config.containerName) : $('body');

        bindEvents();
    }

    function bindEvents() {
        fancyInputContainer.find(inputSelector).each(function () {
            if($(this).val().length > 0) {
                $(this).addClass('filled');
            }
        });
        fancyInputContainer.on('focus', inputSelector, function() {
            $(this).addClass('focus');
        });
        fancyInputContainer.on('click', showHideSelector, function () {
            var showHide = $(this).children(':visible:first');
            if (showHide.hasClass('show')) {
                $(showHide).toggle(false).siblings('.hide').toggle(true);
                $(showHide).parent().siblings('input').attr('type', 'text');
            }
            else {
                $(showHide).toggle(false).siblings('.show').toggle(true);
                $(showHide).parent().siblings('input').attr('type', 'password');
            }
        });
        fancyInputContainer.on('keyup', showHideSelector, function (e) {
            var keys = accessibilityUtil.GetKeys();
            var key = e.keyCode || e.which;
            if(key === keys.enter) {
                var showHide = $(this).children(':visible:first');
                if (showHide.hasClass('show')) {
                    $(showHide).toggle(false).siblings('.hide').toggle(true);
                    $(showHide).parent().siblings('input').attr('type', 'text');
                }
                else {
                    $(showHide).toggle(false).siblings('.show').toggle(true);
                    $(showHide).parent().siblings('input').attr('type', 'password');
                }
            }           
        });
        fancyInputContainer.on('focusout', inputSelector, function () {
            $(this).removeClass('focus');
        });
        fancyInputContainer.on('keyup', inputSelector, function () {
            if ($(this).val().length > 0) {
                $(this).addClass('filled');
            }
            else {
                $(this).removeClass('filled');
            }
        });
        fancyInputContainer.on('blur input', inputSelector, function () {
            if ($(this).val().length > 0) {
                $(this).addClass('filled');
            }
            else {
                $(this).removeClass('filled');
            }
        });
    }

    return {
        init: init
    }
};
HSN.Widget.FancyInput.EVENT = {

};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/FancyInput.js